export default "__VITE_ASSET__FOR6$Ggi__"